export const GET_MERCHANT_APPLICATIONS_PAGINATED = gql`
    query GetMerchantApplicationsPaginated($filters: MerchantApplicationTableFiltersInput) {
        getMerchantApplicationsPaginated(filters: $filters) {
            data {
                id
                status
                merchantName
                partnerName
                partnerOfPartnerName
                serviceType
                worldpayPO
                sellersName
                dateSubmitted
            }
            total
            page
            pageSize
        }
    }
`;
